export interface ParsedCaseNumber {
  prefix: string;
  year: string;
  sequence: number;
}

export const MIN_CASE_NUMBER_SEQUENCE = 1;
export const MAX_CASE_NUMBER_SEQUENCE = 99999;

export function validateCaseNumberSequence(
  value: number | string
): string | null {
  const sequence = Number(value);
  if (
    !Number.isInteger(sequence) ||
    sequence < MIN_CASE_NUMBER_SEQUENCE ||
    sequence > MAX_CASE_NUMBER_SEQUENCE
  ) {
    return `Enter a whole number from ${MIN_CASE_NUMBER_SEQUENCE} to ${MAX_CASE_NUMBER_SEQUENCE}`;
  }
  return null;
}

export function validateSequenceChangeReason(
  value: string,
  changed = true
): string | null {
  return changed && !value.trim() ? "Enter a reason for this change" : null;
}

export function parseCaseNumber(
  caseNumber: string
): ParsedCaseNumber | undefined {
  const match = caseNumber.match(/^([A-Z]+)(\d{2})-(\d+)$/);
  if (!match) return undefined;
  return { prefix: match[1], year: match[2], sequence: Number(match[3]) };
}

export function formatCaseNumber(
  identity: Pick<ParsedCaseNumber, "prefix" | "year">,
  sequence: number
): string {
  return `${identity.prefix}${identity.year}-${String(sequence).padStart(
    5,
    "0"
  )}`;
}
